export default store => ({
  inserted: (el, binding) => {
    let bindRole = binding.value
    let targetIndex = store.state.main.user.roles.findIndex(
      item => item.roleName === bindRole
    )
    if (targetIndex === -1) {
      if (el.parentNode) {
        el.parentNode.removeChild(el)
      }
    }
  }
})